<div
  class="referral-redirect"
  *transloco="let t">
  <img
    class="referral-redirect_image"
    src="/assets/images/project/referral/referral-redirect.svg"
    alt="" />

  <h1 class="referral-redirect_title">{{ t('referrals.redirect.title') }}</h1>
  <p
    class="referral-redirect_description"
    [innerHTML]="t('referrals.redirect.description')"></p>

  <span class="text-gray">
    {{ t('referrals.redirect.please') }}
    <a
      class="link"
      [href]="urlToRedirect"
      >{{ t('referrals.redirect.click-this-link') }}</a
    >
  </span>
</div>
